import { Classes, Dialog, Spinner } from "@blueprintjs/core";
import { FGDateMaskInput, FGTextInput, FieldGroup, useApiEffect } from "nsitools-react";
import * as React from "react";
import ImageGallery from "react-image-gallery";
import styled from "styled-components";

import { BabyDogPublicationDto, BroodRequestApi } from "../../../api";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { DrupalFormGenerator } from "../../common/DrupalFormGenerator";
import { FGSRSHDateMaskInput } from "../../../components";

export interface IBabyDogCardProps {
  babyDog: BabyDogPublicationDto;
}

const StyledImg = styled.img`
  display: block;
  max-width: 460px;
  max-height: 190px;
  width: auto;
  height: auto;
`;

const Container = styled.div`
  border: 1px solid #c2c0c0;
  border-radius: 25px;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const BabyDogCard: React.FunctionComponent<IBabyDogCardProps> = ({ babyDog }) => {
  const { t } = useTl();
  const [dialogOpened, setdialogOpened] = React.useState(false);
  const [startIndex, setstartIndex] = React.useState(0);
  const broodrequestApi = useApiService(BroodRequestApi);

  const [images, loading] = useApiEffect(async () => {
    if (!!babyDog) {
      const driveIds = [];
      if (!!babyDog.puppyPicture1ShpDriveItemId) {
        driveIds.push(babyDog.puppyPicture1ShpDriveItemId);
      }
      if (!!babyDog.puppyPicture2ShpDriveItemId) {
        driveIds.push(babyDog.puppyPicture2ShpDriveItemId);
      }
      if (!!babyDog.puppyPicture3ShpDriveItemId) {
        driveIds.push(babyDog.puppyPicture3ShpDriveItemId);
      }
      console.log("driveIds", driveIds);
      try {
        var imgs = await broodrequestApi.getPuppyPicture(driveIds);
      } catch (e) {
        console.log(e);
      }

      console.log("after the call");
      return imgs.map((img) => {
        return { original: img, thumbnail: img };
      });
    }
  }, [babyDog, broodrequestApi]);
  return (
    <>
      <Container>
        <DrupalFormGenerator initialValues={babyDog} onSubmit={() => {}} editMode={false} hideButtons>
          <FieldGroup columns={2}>
            <div>
              <FGTextInput label={t(ETLCodes.Breeder)} name="breederComputedName" />
              <FGTextInput label={t(ETLCodes.City)} name="breederCity" />
              {!!babyDog?.breederPhoneNumber ? (
                <FGTextInput label={t(ETLCodes.PhoneNumber)} name="breederPhoneNumber" />
              ) : null}
              {!!babyDog?.breederMobileNumber ? (
                <FGTextInput label={t(ETLCodes.MobilePhoneNumber)} name="breederMobileNumber" />
              ) : null}
              <FGTextInput label={t(ETLCodes.Email)} name="breederEmail" />
            </div>
            <div>
              <FGTextInput label={t(ETLCodes.NumberOfAvailablePuppies)} name="availablePuppies" />
              <FGTextInput label={t(ETLCodes.General_Price)} name="price" />
              <FGSRSHDateMaskInput name="birthDate" label={t(ETLCodes.BirthDate)} />
              <div style={{ overflow: "auto" }}>
                {loading ? (
                  <Spinner />
                ) : (
                  <div style={{ display: "flex", marginTop: "0.5rem" }}>
                    {!loading && images?.length > 0 ? (
                      <div
                        className="border"
                        onClick={() => {
                          setstartIndex(0);
                          setdialogOpened(true);
                        }}
                      >
                        <StyledImg src={images[0].original} alt="" />
                      </div>
                    ) : null}
                    {!loading && images?.length > 1 ? (
                      <div
                        className="border"
                        onClick={() => {
                          setstartIndex(1);
                          setdialogOpened(true);
                        }}
                      >
                        <StyledImg src={images[1].original} alt="" />
                      </div>
                    ) : null}
                    {!loading && images?.length > 2 ? (
                      <div
                        className="border"
                        onClick={() => {
                          setstartIndex(2);
                          setdialogOpened(true);
                        }}
                      >
                        <StyledImg src={images[2].original} alt="" />
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            </div>
          </FieldGroup>
        </DrupalFormGenerator>
      </Container>
      <Dialog
        isOpen={dialogOpened}
        onClose={() => setdialogOpened(false)}
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        isCloseButtonShown={true}
        className={Classes.DIALOG}
      >
        <ImageGallery items={images} startIndex={startIndex} />
      </Dialog>
    </>
  );
};
